import React, { useState } from 'react';
import SortLink from './sort-link';
import queryString from 'qs';
import classNames from 'classnames';
import withGeolocation from '../../Containers/withGeolocation';
import CONSTANTS from '../../Pages/findcare/constants';
import * as utils from '../findcare-map/helpers';

function trimStringOrArrayHead(s) {
  if (typeof s === 'string') {
    return s.trim();
  }
  return s[0].trim();
}

const isEmpty = (value) => {
  if (value && trimStringOrArrayHead(value) !== '') return false;
  return true;
};

const sortByRelVisible = (query) => !isEmpty(query.q);

const GeoLocationErrorLink = () => {
  const [isHidden, setIsHidden] = useState(true);

  const handleClick = () => {
    setIsHidden(!isHidden);
  };

  return (
    <li>
      <button
        aria-expanded={!isHidden}
        aria-controls="findcare-sort-error"
        className="findcare-sort__link"
        onClick={() => handleClick()}
      >
        Avstånd
      </button>
      <div
        id="findcare-sort-error"
        aria-hidden={isHidden}
        className={classNames({
          'findcare-sort__error': true,
          'findcare-sort__error--is-visible': !isHidden,
        })}
      >
        Sortering på avstånd är inte möjligt eftersom vi inte kan fastställa din
        position. Se till att aktivera platstjänster.
      </div>
    </li>
  );
};

const hasLatLng = (query) => query.lat && query.lng;

const CoordsContainer = (props) => {
  if ((props.coords && props.coords.latitude) || props.query.g) {
    const o = {
      query: {
        lat: props.coords && props.coords.latitude,
        lng: props.coords && props.coords.longitude,
        q: props.query ? props.query.g : undefined,
      },
    };
    return <SortLink {...o} {...props} />;
  }

  return <GeoLocationErrorLink {...props} />;
};

const DistanceSortLink = (props) => {
  if (hasLatLng(props.query)) return <SortLink {...props} />;

  const DistanceSortLinkContainer = withGeolocation(CoordsContainer);
  return <DistanceSortLinkContainer {...props} />;
};

const FindCareSort = (props) => {
  if (
    !utils.shouldDisplaySort({
      SearchResult: props.SearchResult,
      IsPost: props.IsPost,
    })
  ) {
    return null;
  }
  const [findCareState] = props.findCareState;
  const query = queryString.parse(props.location.search, {
    ignoreQueryPrefix: true,
  });
  if (findCareState.sortWithBoundary) {
    query.b = findCareState.sortWithBoundary;
    delete query.g;
  }

  //Remove page param
  if (query.p) delete query.p;

  // Show name sort only when we have bounds.
  // Other case is we sort all of sweden and that does not make sence.
  // (If we are searching all of sweden we do get bounds).
  const showNameSort = true; // props.SearchResult.Bounds;

  return (
    <ul className="findcare-sort">
      <li>{props.Translations.sortlabel}</li>
      <DistanceSortLink
        s={query.s}
        query={query}
        type={CONSTANTS.SORT_DISTANCE}
      >
        {props.Translations.distance}
      </DistanceSortLink>
      {sortByRelVisible(query) && (
        <SortLink s={query.s} query={query} type={CONSTANTS.SORT_REL}>
          {props.Translations.relevance}
        </SortLink>
      )}
      {showNameSort && (
        <SortLink
          s={!query.s ? CONSTANTS.SORT_NAME : query.s}
          query={query}
          type={CONSTANTS.SORT_NAME}
        >
          {props.Translations.ao}
        </SortLink>
      )}
    </ul>
  );
};

export default FindCareSort;
